<template>
  <main ref="componentParent">
    <div class="container-fluid mb-4 me-4 mt-4">
      <lea-admin-header title="Observer/Learner Assignment" :lea-name="leaName(contextLea)" />
      <div class="alert alert-info text-center" v-if="!schoolYearStore.getters.yearLocked() && lockDate">
        LEA and Role Assignments will be locked on {{ lockDate }}.<br/>
        Only Observer Assignment changes will be allowed for this school year after this date.
      </div>
      <div class="alert alert-warning text-center" v-if="schoolYearStore.getters.yearLocked()">
        LEA and Role Assignments are locked and cannot be changed.<br/>
        Observer Assignments can still be updated.
      </div>
      <div class="card" v-if="showLeaFilter">
        <div class="card-body">
          <div class="form">
            <div class="form-group">
              <label for="lea-filter" class="form-label">LEA Filter</label>
              <select class="form-select" id="lea-filter" aria-label="LEA Filter" v-model="filter.selectedLea">
                userStore.state.SuperintendentDistrictId
                <template v-if="userStore.getters.isDistrictAdmin()">
                  <option value='all'>(All Assignments)</option>
                  <option :value='userStore.state.SuperintendentDistrictId'>(District Assigments &amp; Principals)</option>
                  <option v-for="s in contextSchools" :key="s.lea" :value="s.lea">{{ s.name}} - {{ s.lea }} </option>
                </template>
                <template v-if="userStore.getters.isSchoolAdmin()">
                  <option v-for="s in administeredSchools" :key="s.lea" :value="s.lea">{{ s.name}} - {{ s.lea }} </option>
                </template>
              </select>
            </div>
          </div>
        </div>
      </div>
      <section v-if="rubricsLoaded">
        <ul class="nav nav-tabs nav-fill">
          <li class="nav-item">
            <button class="nav-link active" id="ola-tab" data-bs-toggle="tab" data-bs-target="#olaTab" type="button" role="tab" aria-controls="olaTab" aria-selected="true">
              Observer/Learner Assignments
            </button>
          </li>
          <li class="nav-item">
            <button class="nav-link" id="ola-load-tab" data-bs-toggle="tab" data-bs-target="#observerLoadTab" type="button" role="tab" aria-controls="observerLoadTab" aria-selected="false">
                Observer Load
            </button>
          </li>
        </ul>
        <div class="tab-content">
          <div class="tab-pane fade show active" id="olaTab" role="tabpanel" aria-labelledby="ola-tab">
            <div class="d-flex my-2 justify-content-around">
              <div class="card">
                <div class="card-body text-center">
                  <p class="fw-bold">
                    Unassigned Learners
                  </p>
                  <span class="badge bg-warning">
                    {{ stats.unassigned }}
                  </span>
                </div>
              </div>
              <div class="card">
                <div class="card-body text-center">
                  <p class="fw-bold">
                    Assigned Learners
                  </p>
                  <span class="badge bg-success">
                    {{ stats.assigned }}
                  </span>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body"> 
                <div class="row mb-2">
                  <div class="col">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" v-model="filter.showHiddenLearners" />
                      <label class="form-check-label fw-bold">Show hidden learners</label>
                    </div>
                  </div>
                  <div class="col text-end">
                    <button class="btn btn-primary me-3" v-if="canBulkAssign" @click="showModal = true">Bulk Assign {{ potentialAssignees.length }} Users</button>
                    <button class="btn btn-primary me-3" v-if="defaultAssignmentCandidates.length > 0" @click="onAcceptAllDefaultAssignment">Accept {{ defaultAssignmentCandidates.length }} Default Assignments</button>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <ag-table
                      ref="learnersGrid"
                      style="width: 100%;"
                      class="ag-theme-alpine"
                      :context="context"
                      :columnDefs="columnDefs"
                      :defaultColDef="defaultColDef"
                      row-selection="multiple"
                      :globalSearch="true"
                      :paginationOptions="[10, 25, 50, 100, 250, 500]"
                      @selection-changed="onSelectionChanged"
                      :rowData="filteredLearners"
                      :row-node-id-generator="rowNodeIdGenerator"
                      :get-row-height="getRowHeight"
                    ></ag-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="observerLoadTab" role="tabpanel" aria-labelledby="ola-load-tab">
            <ag-table
                      ref="observerLoadGrid"
                      style="width: 100%;"
                      class="ag-theme-alpine"
                      :columnDefs="observerLoadcolumnDefs"
                      row-selection="multiple"
                      :globalSearch="true"
                      :rowData="filteredObserverLoad"
                      :row-node-id-generator="rowNodeIdGenerator"
                      :get-row-height="getRowHeight"
                      :paginationPageSize="pageSize"
                    ></ag-table>
          </div>
        </div>
      </section>
    </div>

    <!-- Modal -->
    <assignment-modal v-model="showModal" title="Assign Learner(s) to Observer(s)" ok-text="Assign" :ok-callback="onCompleteAssignment">
      <template v-slot:modal-content>
        <form v-if="potentialAssignees && potentialAssignees.length > 0">
          <div v-if="potentialAssignees.length === 1">
            <div class='form-group'>
               <label for="learner">Learner</label>
               <input id="learner" class="form-control" readonly :value="potentialAssignees[0].learnerName" />
            </div>
            <div class="form-group">
               <label for="role">Role</label>
               <input id="role" class="form-control" readonly :value="potentialAssignees[0].learnerRole" />
            </div>
          </div>
          <div v-else>
            <h5>
              Bulk assigning {{ potentialAssignees.length }} learners
            </h5>
          </div>
          <div class="form-group mt-3">
            <label for="assignTo">Assign to Observer(s):</label>
            <v-select multiple placeholder="Select observer(s)" id="assignTo" v-model="assignedObserverIds" :options="potentialObserversForBulkLearners(potentialAssignees)" label="fullName" :reduce="o => o.userId" />
          </div>
        </form>
      </template>
    </assignment-modal>
  </main>
</template>


<script lang="js">
import AgTable from "@/modules/ees/components/AgTable.vue"
import SwitchColumnRenderer from '@/modules/ees/components/ag-table-column-renderer/SwitchColumnRenderer';
import { LearnerStoreKey } from '@/store/StoreInjectionKeys';
import LeaAdminHeader from '../LeaAdminHeader.vue'
import { defineComponent, reactive, ref, computed, onMounted, watch, onBeforeMount } from "@vue/composition-api";
import { ObserverLearnerStoreKey, UserStoreKey, SchoolYearStoreKey } from "@/store/StoreInjectionKeys";
import { injectStrict } from "@/lib/utils";
import useStaffInfo from "@/modules/ees/dataProviders/staffInfo"
import useLeaMetadata from "@/modules/ees/dataProviders/leaMetadata"
import ActionButton from './UnassignedLearnerActionButton';
import AssignmentModal from '@/modules/ees/components/Modal';
import AssignmentStatusCellRenderer from './AssignmentStatusCellRenderer.vue'
import BuildingLEAAssignmentCellRenderer from './BuildingLEAAssignmentCellRenderer.vue'
import LearnerRoleAssignmentCellRenderer from './LearnerRoleAssignmentCellRenderer.vue'
import LearnerStatusCellRenderer from './LearnerStatusCellRenderer.vue'
import ScienceOfReadingStatusCellRenderer from './ScienceOfReadingStatusCellRenderer'
import { AssignableLearnerRole, StaffRoleTypeEnum } from "@/generated/api.clients";
import { dateTimeRenderer } from '@/modules/ees/components/ag-table-column-renderer/HtmlCellRenderers'
import { useLearnerStatus, useScienceOfReadingStatus } from '@/modules/ees/dataProviders/metadata'
import { useRubrics, useRoles } from '@/modules/ees/dataProviders/metadata'

import groupBy from 'lodash.groupby'
export default defineComponent({
  components: {
    AgTable,
    AssignmentModal,
    LeaAdminHeader
  },
  setup() {
    const observerLearnerStore = injectStrict(ObserverLearnerStoreKey);
    const learnerStore = injectStrict(LearnerStoreKey);
    const userStore = injectStrict(UserStoreKey);
    const schoolYearStore = injectStrict(SchoolYearStoreKey);
    const { rubrics, rubricsLoaded } = useRubrics()
    const roles = useRoles().roles 

    const rolesWithRubrics = computed(() => {
      return roles.filter(r => rubrics.active.filter(ru => ru.targetStaff.includes(r.value)).length > 0)
    })

    const filter = reactive({
      selectedLea: 'all',
      showHiddenLearners: false
    })

    const learnersGrid = ref(null)
    const selectedLea = ref(null)
    const assignedObserverIds = ref([])
    const showModal = ref(false)
    const component = ref(null)
    const componentParent = ref(null)
    const currentlyCheckedRows = ref([]);
    const contextLea = ref('')
    const learnerStatuses = useLearnerStatus()
    const scienceOfReadingStatuses = useScienceOfReadingStatus()
    const pageSize = ref(50)

    const context = { 
      componentParent: null,
      assignmentFunction: null,
      removeAssignmentFunction: null,
      toggleHidden: null
    }

    const { contextSelectedDistrict, contextSchools, administeredSchools, loadLeas, leaName, isDistrict, isCoop } = useLeaMetadata(userStore.state.AdministeredSchoolLEAs)

    onBeforeMount(async () => {
      contextLea.value = userStore.state.SuperintendentDistrictId || userStore.state.AdministeredSchoolLEAs[0]
      contextSelectedDistrict.value = contextLea.value
      filter.selectedLea = 'all' 

      await loadLeas()
      await schoolYearStore.actions.getCurrentSchoolYear();
      //await loadData()
    })

    onMounted(() => {
      context.assignmentFunction = initializeAssignment
      context.removeAssignmentFunction = removeAssignment
      context.toggleHidden = toggleHidden
    })


    const loadData = async () => {
      return await Promise.all([observerLearnerStore.actions.getObserverLearnerAssignments(contextLea.value), 
        observerLearnerStore.actions.getObserverLoad(contextLea.value)
      ])
    }
   

    watch(() => filter.selectedLea, (newLea) => {
      if (userStore.getters.isSchoolAdmin()) {
        //we only need to update the contextLea when the user is a School Admin. District Admins load all staff in the district to begin with.
        contextLea.value = filter.selectedLea
      }
    }, { immediate: false });

    watch(contextLea, (newLea) => {
      loadData()
    }, { immediate: false });

    const { staff } = useStaffInfo(contextLea)

    const onAcceptDefaultAssignment = async (data) => {
      assignedObserverIds.value = [data.defaultObserverUserId]
      onCompleteAssignment()
    }

    const filterCallback = (row) => {

      const buildingAdminRoles = ['Principal', 'Assistant Principal']
      const filteringForDistrictPositions = /\d{4}[07]00/.test(filter.selectedLea)

      var passesFilter = (filter.selectedLea == 'all') || 
        (row.learnerBuildingLEA === filter.selectedLea || (filteringForDistrictPositions && buildingAdminRoles.includes(row.learnerRole)))

      if (passesFilter) {
        passesFilter = (filter.showHiddenLearners && row.isHidden) || (!(filter.showHiddenLearners || row.isHidden))
      }

      return passesFilter
    }

    const filteredLearners = computed(() => {
      return observerLearnerStore.state.observerLearnerAssignments.filter(filterCallback)
    })

    const filteredObserverLoad = computed(() => {
      return observerLearnerStore.state.observerLoad.filter(l => filter.selectedLea == 'all' || l.districtLEA == filter.selectedLea || l.schoolLEA == filter.selectedLea)
    })

    const stats = computed(() => {
      return {
        unassigned: filteredLearners.value.filter(i=>!i.isAssigned).length,
        assigned: filteredLearners.value.filter(i=>i.isAssigned).length,
      }
    })

    const onUpdateLearnerConfiguration = async (learnerSummativeData) => {
      console.log('updating configuration')
//      if (learnerSummativeData.learnerRoleType && learnerSummativeData.learnerBuildingLEA) {
        //assign the active rubric version id for the learner's role type
        learnerSummativeData.rubricVersionId = rubrics.forRole(learnerSummativeData.learnerRoleType)?.activeVersionId
        observerLearnerStore.actions.configureLearnerSummativeData(learnerSummativeData.learnerSummativeDataId, learnerSummativeData.learnerBuildingLEA, learnerSummativeData.learnerRoleType, learnerSummativeData.rubricVersionId)
        if (learnersGrid.value) learnersGrid.value.gridOptions.api.refreshCells()
//      }
    }

    const getRowHeight= function (params) {
      const observerExtra = ((((params.data.assignedObserverItems || []).length) || 1) - 1) * 23
      return 50 + observerExtra
    }

    const actions = {
      learnerStatusChanged(node, status) {
        observerLearnerStore.actions.setLearnerStatus(node.data.learnerSummativeDataId, status)
      },
      scienceOfReadingStatusChanged(node, status) {
        observerLearnerStore.actions.setLearnerScienceOfReadingStatus(node.data.learnerSummativeDataId, status)
      },
      virtualEducatorChanged(node, isVirtualEducator) {
        learnerStore.actions.setLearnerVirtualEducator({ ids: [node.data.learnerSummativeDataId], isVirtualEducator: isVirtualEducator})
      }
    }

    const defaultColDef = { cellStyle: {padding: '5px' } }

    const columnDefs = [
      {  
        cellRendererFramework: AssignmentStatusCellRenderer,
        type: ['nonFilterable'], 
        width: 140,
        valueGetter: (params) => {
          return params.data.isAssigned ? 'Assigned' : (!(params.data.learnerBuildingLEA || params.data.learnerRoleType)) ? 'Select LEA / Role' : !(params.data.learnerBuildingLEA) ? 'Select LEA' : !(params.data.learnerRoleType) ? 'Select Role' : params.data.rubricVersionId ? 'Assign Observer(s)' : 'Error' 
        }
      },
      { field: "learnerName", width: 150, headerName: 'Name' },
      { 
        field: "learnerBuildingLEA", 
        headerName: 'LEA', 
        width: 110, 
        cellStyle: {padding: '0px 2px'},
        cellRendererFramework: BuildingLEAAssignmentCellRenderer, 
        cellRendererParams: { 
          updateCallback: onUpdateLearnerConfiguration,
          locked: schoolYearStore.getters.yearLocked,
          isDistrictAdmin: userStore.getters.isDistrictAdmin,
          isSchoolAdmin: userStore.getters.isSchoolAdmin,
          contextSchools: contextSchools,
          administeredSchools: administeredSchools,
          districtLEA: userStore.state.SuperintendentDistrictId
        } 
      },
      { 
        field: "learnerRole", 
        headerName: 'Role', 
        width: 225, 
        cellStyle: {padding: '0px 2px'},
        cellRendererFramework: LearnerRoleAssignmentCellRenderer, 
        cellRendererParams: {
          roles: rolesWithRubrics,
          updateCallback: onUpdateLearnerConfiguration,
          locked: schoolYearStore.getters.yearLocked
        }
      },
      {
        headerName: 'Rubric',
        valueGetter: (params) => { return rubrics.forRole(params.data.learnerRoleType)?.name || '(Select Role)'; },
        width: 350, 
      },
      { 
        field: "learnerStatus", 
        headerName: 'Status',
        width: 140, 
        cellStyle: {padding: '0px'},
        filterValueGetter: params => learnerStatuses.statusByValue(params.data.learnerStatus).text,
        cellRendererFramework: LearnerStatusCellRenderer, 
        cellRendererParams: {
          learnerStatuses: learnerStatuses,
          onSelectionChangedCallback: actions.learnerStatusChanged
        }
      },
      {
        field: "activeDirectoryUserId",
        headerName: 'User ID',
        flex: 1, 
      },
      {
        field: "lastEncounteredDate",
        headerName: 'Last Encountered', 
        flex: 1, 
        cellRenderer: dateTimeRenderer,
      },
      { 
        field: "assignedObserverItems", width: 200, headerName: 'Observer(s)', cellRenderer: (params) => {
          if (params.value && params.value.length) {
            return '<ul class="list-unstyled pt-2" style="line-height:25px;">' + params.value.map(p => `<li>${p.name}</li>`).join('') + '</ul>'
          } else {
            if (params.data.defaultObserverUserId) {
              return `<i>(Default: ${params.data.defaultObserverName})</i>`
            } else {
              return "(Not Assigned)"
            }
          }
        } 
      },
      {
        field: "isSelected",
        type: ['nonSortable', 'nonFilterable'],
        headerName: '',
        sortable: false,
        checkboxSelection: (params) => { return params.data.learnerBuildingLEA && params.data.rubricVersionId },
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 20
      },
      {
        field: 'Action',
        type: ['nonSortable', 'nonFilterable'],
        cellRendererFramework: ActionButton,
        cellRendererParams: {
          infoCallback: (roleType, assignedLea, learnerUserId) => {
            return potentialObserversForLearner(roleType, assignedLea, learnerUserId)
          },
          acceptDefaultAssignmentCallback: onAcceptDefaultAssignment
        },
        cellClass: 'actions-button-cell', width: 100
      }
    ]

    const observerLoadcolumnDefs = [
      { field: 'districtLEA', flex: 1 },
      { field: 'fullName', flex: 1, headerName: "Observer Name" },
      { field: 'schoolLEA', flex: 1 },
      { field: 'learnerCount', flex: 1 }
    ]

    const potentialObserversForBulkLearners = (assigneeLearners) => {
      return potentialObserversForLearner(assigneeLearners[0].learnerRoleType, assigneeLearners[0].learnerBuildingLEA, assigneeLearners[0]?.learnerUserId)
    }

    const potentialObserversForLearner = (roleType, assignedLea, learnerUserId) => {
      // console.log('Curriculum Supervisor:', ...staff.all.filter(s => s.jobFunction == "Curriculum Supervisor"))
      // console.log('Special Education Supervisor:', ...staff.all.filter(s => s.jobFunction == "Special Education Supervisor"))
      // console.log('Federal Programs:', ...staff.all.filter(s => s.jobFunction == "Federal Programs"))
      let observers = []
      if (isDistrict(assignedLea) || roleType == StaffRoleTypeEnum.Principal) {
        observers = [...staff.districtLevelObservers, ...staff.generalObserverByLea(assignedLea)]
      } else if (isCoop(assignedLea)) {
        observers = staff.virtualEvaluators 
      } else if (roleType == StaffRoleTypeEnum.AssistantPrincipal) {
        observers = [...staff.districtLevelObservers,  ...staff.otherPotentialObservers, ...staff.districtLevelGeneralObserver, ...staff.principalsForDistrict, ...staff.generalObserverByLea(assignedLea)]
      } else {
        console.log('Other potential observers', ...staff.otherPotentialObservers)
        observers = [...staff.districtLevelObservers, ...staff.effectivenessSystemCoordinators, ...staff.otherPotentialObservers, ...staff.districtLevelGeneralObserver, ...staff.principalsForDistrict, ...staff.generalObserverByLea(assignedLea)]
      }

      observers = observers.filter(o => o.userId != learnerUserId || '')
      .map(p => { 
        return { ...p, fullName: `${p.lastName}, ${p.firstName} - ${p.activeDirectoryUserId}`  }
      });

      let idSet = new Set();
      let result = [];

      observers.forEach(o =>{
        if(idSet.has(o.uniqueEmployeeId) === false){
          result.push(o);
          idSet.add(o.uniqueEmployeeId);
        }
      });

      return result.sort((a,b) => a.fullName.localeCompare(b.fullName));
    }

    const initializeAssignment = (params) => {
      assignedObserverIds.value = (params.assignedObserverItems || []).map(o=>o.observerId)
      showModal.value = true
    }

    const onAcceptAllDefaultAssignment = async () => {
      const groupedByObserver = groupBy(defaultAssignmentCandidates.value, (item)=>item.defaultObserverUserId);

      for (const [key, value] of Object.entries(groupedByObserver)) {
          const assignees = value.map(m=>new AssignableLearnerRole({ learnerSummativeDataId: m.learnerSummativeDataId, learnerUserId: m.learnerUserId, learnerRoleType: m.learnerRoleType, learnerBuildingLEA: m.learnerBuildingLEA}))
          const results = await observerLearnerStore.actions.saveObserverLearnerAssignments([key],
                          assignees)
      }
      loadData()
    }
 
    const onCompleteAssignment = async () => {
      const assignees = potentialAssignees.value.map(m => new AssignableLearnerRole({ 
        learnerUserId: m.learnerUserId, 
        learnerRoleType: m.learnerRoleType, 
        learnerSummativeDataId: m.learnerSummativeDataId
      }))

      const results = await observerLearnerStore.actions.saveObserverLearnerAssignments(assignedObserverIds.value, assignees)
      await observerLearnerStore.actions.getObserverLoad(contextLea.value)

      const resultsByLearnerSummativeDataId = groupBy(results, r => r.learnerSummativeDataId)

      Object.keys(resultsByLearnerSummativeDataId).forEach(key => {
        const observers = resultsByLearnerSummativeDataId[key]
        const row = learnersGrid.value.gridOptions.api.getRowNode(key)
        setRowAssignedObservers(row, observers.map(r=> { return { id: r.id, observerId: r.observerUserId, name: r.observerName }}))
      })

      learnersGrid.value.gridOptions.api.onRowHeightChanged()
      learnersGrid.value.gridOptions.api.deselectAll()
      assignedObserverIds.value = []
      currentlyCheckedRows.value = []
      showModal.value = false
    }

    const setRowAssignedObservers = (rowNode, observers) => {
      rowNode.data.assignedObserverItems = observers
      rowNode.data.isAssigned = observers.length > 0
      rowNode.setRowHeight()
      learnersGrid.value.gridOptions.api.refreshCells({ rowNodes: [rowNode]})
    }

    const canBulkAssign = computed(()=>{ 
      var distinctLeas = [...new Set(potentialAssignees.value.map(x=>x.learnerBuildingLEA))]
      var distinctRoles = [...new Set(potentialAssignees.value.map(x=>x.learnerRole))]
      return potentialAssignees.value.length > 1 && 
        (distinctLeas.length === 1 || //have to all be in the same LEA
         (distinctRoles.length == 1 && distinctRoles[0] == 'Principal')) //or they have to all be prinicipals
    });

    const onSelectionChanged = (event) => {
      currentlyCheckedRows.value = [...event.selectedRows]
    };

    const rowNodeIdGenerator = (data) => {
      return data.learnerSummativeDataId
    }

    const potentialAssignees = computed(() => currentlyCheckedRows.value.filter(r=>r.learnerRoleType != null).map(r=>{return {learnerSummativeDataId: r.learnerSummativeDataId, learnerUserId: r.learnerUserId, learnerName: r.learnerName, learnerRole: r.learnerRole, learnerRoleType: r.learnerRoleType, learnerBuildingLEA: r.learnerBuildingLEA }}))
    const defaultAssignmentCandidates = computed(() => {
      return filteredLearners.value.filter(f=>f.rubricVersionId && f.defaultObserverUserId && !f.isAssigned)
    })
    
    const removeAssignment = (params) => {
      return observerLearnerStore.actions.clearObserverLearnerAssignments(params.data.learnerSummativeDataId).then(() => {
        setRowAssignedObservers(params.node, [])
        learnersGrid.value.gridOptions.api.onRowHeightChanged()
      })
    }

    const toggleHidden = (params) => {
      return observerLearnerStore.actions.toggleLearnerHidden(params.learnerSummativeDataId, params.isHidden).then(() => {
        learnersGrid.value.gridOptions.api.refreshCells()
      })
    }

    const showLeaFilter = computed(() => userStore.getters.isDistrictAdmin() || (userStore.getters.isSchoolAdmin && userStore.state.AdministeredSchoolLEAs.length > 1))
    return {
      filter,
      filteredLearners,
      learnersGrid,
      getRowHeight,
      showLeaFilter,
      contextLea,
      component,
      componentParent,
      context,
      defaultColDef,
      columnDefs,
      currentlyCheckedRows,
      observerLearnerStore,
      onSelectionChanged,
      staff,
      userStore,
      initializeAssignment,
      showModal,
      potentialAssignees,
      onCompleteAssignment,
      assignedObserverIds,
      canBulkAssign,
      potentialObserversForBulkLearners,
      rowNodeIdGenerator,
      defaultAssignmentCandidates,
      onAcceptDefaultAssignment,
      onAcceptAllDefaultAssignment,
      contextSchools,
      administeredSchools,
      stats,
      filterCallback,
      actions,
      leaName,
      observerLoadcolumnDefs,
      filteredObserverLoad,
      schoolYearStore,
      rubricsLoaded,
      lockDate: computed(() => schoolYearStore.state.SchoolYear.leaBuildingAndRoleAssignmentLockDate?.toLocaleDateString("en-US", {year: 'numeric', month: 'long', day: 'numeric' })),
      pageSize
    }
  }
})
</script>